<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('cancel')">
        <div class="modal-container" @click.stop>
          <div class="modal-header d-sm-block d-none">
            <slot name="header"> <h1>Offer Details</h1> </slot>
          </div>

          <div class="d-sm-none">
            <b-button-close @click="$emit('cancel')"/>
            <h4>Offer Details</h4>
          </div>

          <div class="modal-body">
            <slot name="body">
              <b-row>
                <b-col cols="12" v-if="!submittedSucessfully">
                  <b-row>
                    <b-col cols="12" sm="8">
                      <b-form-row>
                        <b-col cols="12" sm="6" class="col-form-key">
                          Watches in Stock
                        </b-col>
                        <b-col cols="12" sm="6">
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            v-model="watchesOnStock"
                            min="0"
                            :disabled="currentlySending"
                          />
                        </b-col>
                      </b-form-row>
                      <b-form-row>
                        <b-col cols="12" sm="6" class="col-form-key">
                          Not in stock, but possible to order
                        </b-col>
                        <b-col cols="12" sm="6">
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            v-model="watchesToAccess"
                            min="0"
                            :has-error="watchesToAccess && watchesToAccess > 0"
                            :disabled="currentlySending"
                          />
                          <p style="color:red;" v-if="!watchesToAccess && watchesToAccessDate">
                            Please set the number of watches, you will have access to.
                          </p>
                          <p style="color:red;" v-if="watchesToAccess && watchesToAccess <= 0">
                            Please put in a value greater than 0 or leave this field empty.
                          </p>
                        </b-col>
                      </b-form-row>
                      <b-form-row>
                        <b-col cols="12" sm="6" class="col-form-key">
                          Watches not in stock ready to ship by
                        </b-col>
                        <b-col cols="12" sm="6">
                          <input
                            type="text"
                            id="datepicker"
                            class="form-control form-control-sm"
                            v-model="watchesToAccessDate"
                          />
                          <p style="color:red;" v-if="watchesToAccess && !watchesToAccessDate">
                            Please select the date, when your watches not in stock are ready to ship.
                          </p>
                        </b-col>
                      </b-form-row>
                      <b-form-row>
                        <b-col cols="12" sm="6" class="col-form-key">
                          Price / Currency
                        </b-col>
                        <b-col cols="12" sm="6">
                          <div class="input-group">
                            <input
                                type="number"
                                id="price"
                                class="form-control form-control-sm"
                                v-model="watchPrice"
                            />
                            <b-form-select
                              id="currency"
                              class="form-control form-control-sm"
                              v-model="watchCurrency"
                              :options="availableCurrencies"
                              size="sm"
                            >
                            </b-form-select>
                          </div>
                          <p style="color:red;" v-if="watchPrice < 1">
                            Please enter your offer price.
                          </p>
                        </b-col>
                      </b-form-row>
                      <b-form-row>
                        <b-col cols="12" sm="6" class="col-form-key">
                          Taxation
                        </b-col>
                        <b-col cols="12" sm="6">
                          <b-form-select
                              id="taxation"
                              class="form-control form-control-sm"
                              size="sm"
                              v-model="watchTaxation"
                              :options="availableTaxations"
                          ></b-form-select>
                          <p style="color:red;" v-if="watchTaxation === '' && watchTaxation === 'not specified'">
                            Please enter the taxation mode.
                          </p>
                        </b-col>
                      </b-form-row>
                      <b-form-row>
                        <b-col cols="12" sm="6" class="col-form-key">
                          Comment
                        </b-col>
                        <b-col cols="12" sm="6">
                          <textarea
                            class="form-control form-control-sm"
                            v-model="offerComment"
                            :disabled="currentlySending"
                          ></textarea>
                        </b-col>
                      </b-form-row>
                    </b-col>
                    <b-col cols="12" sm="4" class="text-center">
                      <div v-if="!currentlySending">
                        <b-button :variant="isValidOffer ? 'success' : 'secondary'" size="lg"
                          class="btn-offer"
                          @click="isBigOrder ? showConfirmDialog() : submitOffer()"
                          :disabled="!isValidOffer"
                        >
                          Submit Offer
                        </b-button>
                        * non-binding
                      </div>
                      <div class="sending-offer-div" v-if="currentlySending">
                        Sending &nbsp; <b-spinner/>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" v-else class="text-center">
                  <div class="alert alert-success alert-offer-value-success">
                    <b-iconstack scale="1.5">
                      <b-icon stacked icon="circle-fill"></b-icon>
                      <b-icon stacked icon="check" variant="white" scale="0.8"></b-icon>
                    </b-iconstack>
                    Successfully sent offer<br /><br />
                    <b-button variant="success" @click="$emit('cancel')">
                      <b-icon-x/> Close
                    </b-button>
                  </div>
                </b-col>
                <b-col cols="12" v-if="error.addOffer" class="text-left mt-3">
                  <div class="alert alert-danger" role="alert">
                    Your offer could not be sent. Please contact us at
                    <a href="mailto:b2b@chronext.com">b2b@chronext.com</a> if the problem persists.
                  </div>
                </b-col>
                <b-modal
                  v-model="showAmountConfirmationModal"
                  size="lg"
                  title="Confirm Amount"
                  ok-title="Confirm"
                  ok-variant="success"
                  @ok="submitOffer"
                >
                  <div class="alert alert-warning">
                    <b-icon-alert-circle scale="2"/> You entered a high number of watches.<br />
                    Are you sure you want to offer
                    <span v-if="watchesOnStock > 0"
                      ><strong>{{ watchesOnStock }}</strong> watches in stock</span
                    ><span v-if="watchesOnStock > 0 && watchesToAccess > 0"> and </span
                    ><span v-if="watchesToAccess > 0"
                      ><strong>{{ watchesToAccess }}</strong> watches in access</span
                    >?
                  </div>
                </b-modal>
              </b-row>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import constants from 'src/constants/constants';
import apiAuth from 'src/clients/apiAuth';
import { getUser } from 'src/auth';
import Pikaday from 'pikaday';
import { timeFormatMixin } from 'Mixins/timeFormatMixin';

const BIG_OFFER_AMOUNT_TRESHOLD = 10;
const AVAILABLE_CURRENCIES = ['EUR', 'USD', 'CHF', 'SGD', 'GBP', 'HKD', 'JPY'];
const AVAILABLE_TAXATIONS = ['0% VAT', 'margin tax', 'incl. local VAT'];

export default {
  name: 'OfferForm',
  props: ['demand', 'offerData'],
  mixins: [timeFormatMixin],
  data: function() {
    return {
      watchesOnStock: '',
      watchesToAccess: '',
      watchesToAccessDate: null,
      currentlySending: false,
      submittedSucessfully: false,
      showAmountConfirmationModal: false,
      watchPrice: 0.0,
      watchCurrency: 'EUR',
      watchTaxation: 'not specified',
      offerComment: '',
      error: {
        addOffer: false,
      },
    };
  },
  computed: {
    isBigOrder: function() {
      return this.watchesOnStock > BIG_OFFER_AMOUNT_TRESHOLD || this.watchesToAccess > BIG_OFFER_AMOUNT_TRESHOLD;
    },
    availableCurrencies: () => AVAILABLE_CURRENCIES,
    availableTaxations: () => AVAILABLE_TAXATIONS,
    isValidOffer() {
      return (
          this.watchPrice > 0 &&
          this.watchTaxation !== '' && this.watchTaxation !== 'not specified' &&
          (
              (this.watchesOnStock && (!this.watchesToAccessDate && !this.watchesToAccess)) ||
              (this.watchesOnStock && (this.watchesToAccessDate && this.watchesToAccess)) ||
              (this.watchesToAccessDate && this.watchesToAccess)
          )
      );
    },
  },
  methods: {

    showConfirmDialog() {
      this.showAmountConfirmationModal = true;
    },
    submitOffer() {
      if (!this.isValidOffer) {
        return false;
      }

      let options = {
        method: 'post',
        url: constants.url.offerService.baseUrl + constants.url.offerService.api.purchaseOffers.create,
        data: {
          positionComment: this.offerComment,
          variantKey: this.demand['variantKey'],
          productKey: this.demand['productKey'],
          demandId: null,
          currency: this.watchCurrency,
          price: Math.round(this.watchPrice * 100),
          tax: this.watchTaxation,
          watchesToAccessDate: this.watchesToAccessDate,
          watchesOnStock: parseInt(this.watchesOnStock),
          watchesToAccess: parseInt(this.watchesToAccess),
          userEmail: getUser()['email'],
        },
      };
      this.currentlySending = true;
      this.error.addOffer = false;
      apiAuth(options)
        .then(() => {
          this.submittedSucessfully = true;
          this.currentlySending = false;

          this.$ga.event({
            eventCategory: 'OfferForm',
            eventAction: 'click_submit_offer_button',
            eventLabel: 'Submit Offer for demand ' + this.demand['demandId'],
          });
        })
        .catch(() => {
          this.error.addOffer = true;
          this.currentlySending = false;
          this.error.addBid = true;
        });
    },
  },
  mounted: function() {
    let self = this;
    new Pikaday({
      field: document.getElementById('datepicker'),
      format: 'yyyy-MM-dd',
      toString(date) {
        return self.formattedDate(date);
      },
      parse(dateString) {
        return self.parseDate(dateString);
      },
      onSelect: function() {
        self.watchesToAccessDate = this.toString();
      },
    });
  },
};
</script>

<style lang="scss" scoped>
.sending-offer-div {
  font-size: 1.3rem;
}

.col-form-key {
  text-align: right;
  @media all and (max-device-width: 576px) {
    text-align: left;
    font-size: 14px;
  }
}

.btn-offer {
  width: 100%;
}

.alert-offer-value-success {
  margin-bottom: 0;
}

.row-form {
  margin-bottom: 8px;
}
</style>
